/* Publish by EComposer at 2026-09-25 14:28:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-127ib1nx6gaj"]=  window.__ectimmers["ecom-127ib1nx6gaj"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-127ib1nx6gaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-127ib1nx6gaj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-crht4rn4577').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-crht4rn4577', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xlsrj930lah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xlsrj930lah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-txalp204qeo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-txalp204qeo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ncx3zsy2iv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ncx3zsy2iv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2wvk3l7yvcx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2wvk3l7yvcx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyscjl8oco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyscjl8oco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9paoes7qtn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9paoes7qtn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j718r30gjt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j718r30gjt', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mx8qp2fhuh"]=  window.__ectimmers["ecom-mx8qp2fhuh"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-mx8qp2fhuh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mx8qp2fhuh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0pfce6mt0o9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0pfce6mt0o9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mg7k6rw9bx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mg7k6rw9bx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3qol1pqlom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3qol1pqlom', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zye1eatlnof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zye1eatlnof', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3bwn07d4pjw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3bwn07d4pjw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hefk7wge0dk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hefk7wge0dk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}